/**
 * **WitBooking New Version**
 *
 * @exports bs_27
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  const dataLayer = window.dataLayer;

  /**
   * @memberOf module:bs_27
   * @see {@link onStateChange}
   *
   * @param {object} ctx - The context object.
   */
  engine.onStateChange = thn.debounce(function (ctx) {
    const isBookingEngine = window.location.hostname.match(/reservation|engine|booking/);
    const isSpaHomepage = [1016571, 1033285, 1039101].includes(thn.data.propertyId) && !isBookingEngine;
    if (isBookingEngine) {
      thn.languageCheck();
    }
    if (isSpaHomepage) {
      thn.pageCheck();
    }
  }, 900);

  /**
   * @memberOf module:bs_27
   * @see {@link prestart}
   *
   * @param {object} ctx - The context object.
   */
  engine.boot = function boot() {
    const refreshPageEvent = ({ message }) => {
      if (message.content_subcategory) {
        thn.languageCheck();
        thn.pageCheck();
      }
    };

    thn.bus.on('dataLayer:push', refreshPageEvent, true);
    thn.shutdown(() => {
      thn.bus.detach('dataLayer:push', refreshPageEvent);
    });

    const mainContainer = document.querySelector('main [id*="headlessui-tabs-panel-:Rqhavm"], main');
    const loader = document.querySelector('.MuiSkeleton');

    if (mainContainer) {
      const refreshPageByMain = thn.debounce(() => {
        if (!loader) {
          thn.pageCheck();
        }
      }, 800);

      thn.observeDom(mainContainer, refreshPageByMain, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      thn.shutdown(() => {
        refreshPageByMain.cancel();
        thn.stopObserveDom(mainContainer, refreshPageByMain);
      });
    }
  };

  /**
     * @memberOf module:bs_1
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {
    return !!(window.WitBooking?.currentUser);
  };

  /**
   * @memberOf module:bs_27
   * @see {@link language_check}
   *
   * @param {object} ctx - The context object.
   */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      const langSel = '.btn-idioma button, .wrap-language-btn.js-toggle-popup, .wpml-ls-native';
      const langEl = document.querySelector(langSel)?.textContent?.trim()?.toLowerCase() || document.querySelector('html').getAttribute('lang');
      const urlLang = window.location.pathname.match(ctx.urlRe)?.[1];
      const lang = urlLang || langEl;

      if (lang && lang === 'default') {
        resolve('es');
        return;
      }

      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }

      reject('no_language');
    });
  };
  /**
  * @memberOf module:bs_27
  * @see {@link generate_search_url}
  *
  * @param {object} ctx - The context object.
  */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    // https://reservations.zinema7hotel.com/es/hotel/zinema7hotel.com
    // https://booking.atlantesanxenxo.com/es/hotel/atlante?adultos=1&checkin=1&checkin_month=November&checkin_year=2025&checkout=3&checkout_month=November&checkout_year=2025&datein=01-11-2025&dateout=03-11-2025&kitt_id=157601e8fe51fbf3&ninos=2&bebes=0&origin=web&utm_source=thn_kitt_chat
    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.match(/reservation|engine|booking/);
    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }
    const dateBegin = new Date(ctx.newData.dateBegin?.replace(/\//g, '-'));
    const dateEnd = new Date(ctx.newData.dateEnd?.replace(/\//g, '-'));

    if (dateBegin && dateEnd) {
      // Date begin data
      const yearBegin = dateBegin.getFullYear().toString();
      const monthBegin = dateBegin.toLocaleString('en-US', { month: 'long' });
      const dayBegin = dateBegin.getDate().toString();

      // Date end data
      const yearEnd = dateEnd.getFullYear().toString();
      const monthEnd = dateEnd.toLocaleString('en-US', { month: 'long' });
      const dayEnd = dateEnd.getDate().toString();

      // Delete the existing parameter
      url.searchParams.delete('_gl');

      // Prepare URL for params substitution
      url.searchParams.set('datein', '[date_begin]');
      url.searchParams.set('dateout', '[date_end]');
      url.searchParams.set('origin', 'web');
      url.searchParams.set('prom', '');
      url.searchParams.set('checkin', dayBegin);
      url.searchParams.set('checkin_month', monthBegin);
      url.searchParams.set('checkin_year', yearBegin);
      url.searchParams.set('checkout', dayEnd);
      url.searchParams.set('checkout_month', monthEnd);
      url.searchParams.set('checkout_year', yearEnd);
      url.searchParams.set('adultos', '[adults]');
      url.searchParams.set('ninos', (ctx.data.roomsDispo?.[0]?.childrenAges?.filter((age) => age > 2)?.length || 0));
      url.searchParams.set('bebes', (ctx.data.roomsDispo?.[0]?.childrenAges?.filter((age) => age <= 2)?.length || 0));
      ctx.newUrl = url.toString();
      ctx.newData.dateBegin = ctx.newData.dateBegin?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$2-$1');
      ctx.newData.dateEnd = ctx.newData.dateEnd?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$2-$1');
    }
    return ctx;
  };

  /**
   * @memberOf module:bs_27
   * @this thn.widgets.price
   * @see {@link Price#observe_dom}
   *
   * @param {object} ctx - The context object.
   */
  engine.priceObserveDom = function priceObserveDom() {
    const refreshPrice = thn.debounce(() => thn.widgets.price.refresh(), 600);
    const container = document.querySelector('[id*="headlessui-tabs-panel-:rr:"]');

    const eventsToRefreshPrice = ({ message }) => {
      if (message.event === 'gtm.historyChange-v2'
        || message['gtm.elementId'].match(/headlessui-menu-item/) || message.content_subcategory === 'Search completed') {
        refreshPrice();
      }
    };

    thn.bus.on('dataLayer:push', eventsToRefreshPrice);

    thn.pageUnload(() => {
      thn.bus.detach('dataLayer:push', eventsToRefreshPrice);
      refreshPrice.cancel();
    });

    if (container) {
      thn.observeDom(container, refreshPrice, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      thn.pageUnload(() => {
        refreshPrice.cancel();
        thn.stopObserveDom(container, refreshPrice);
      });
    }
  };

  /**
   * @memberOf module:bs_27
   * @this thn.widgets.price
   * @see {@link Price#set_data}
   *
   * @param {object} ctx - The context object.
   */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    if (window.location.pathname.match(/room/)) {
      widgetData.priceSpecial = 1;
    }

    // Dates
    const dateBegin = thn.objectGet(dataLayer, 'checkInDate', { first: false });
    const dateEnd = thn.objectGet(dataLayer, 'checkOutDate', { first: false });

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin.replace(/-/g, '/');
      widgetData.dateEnd = dateEnd.replace(/-/g, '/');
    }

    // Guests, Adults & Children
    const adults = thn.dataLayerHelper.get('totalAdults') || 2;
    const children = thn.dataLayerHelper.get('totalChildren') || 0;
    const babies = thn.dataLayerHelper.get('totalBabies') || 0;

    widgetData.adults = adults;
    widgetData.children = children + babies;

    // Prices & Currency || No Rooms
    const availablePriceEls = [...document.querySelectorAll('span.font-bold.text-property-h1')].filter((priceEl) => thn.isVisible(priceEl));
    const filterApplied = document.querySelector('[id="headlessui-menu-button-:rl:"], div.bg-primary-100.text-primary-contrast')?.textContent?.match(/escapadas|retiros|abhebungen|ausflugsziele|retreats|getaways|retraits|escapades/i);

    if (thn.empty(availablePriceEls) && filterApplied) {
      widgetData.set = false;
      thn.widgets.price.hide();
      return widgetData;
    }

    if (thn.empty(availablePriceEls) && !document.querySelector('main [id*="headlessui-tabs-panel-:Rqhavm"] .opacity-40')) {
      widgetData.noRooms = true;
      return widgetData;
    }
    const prices = availablePriceEls.map((price) => thn.parseNumber(price?.textContent.concat('.', price.nextSibling?.textContent))).filter(Boolean);
    const currency = thn.parseCurrency(availablePriceEls[0]?.parentElement?.nextSibling?.querySelector('span')?.textContent) || document.querySelector('.text-property-body3>.mr-1')?.textContent;

    // Mark the price as special if there is a filter applied
    if (filterApplied) {
      widgetData.priceSpecial = 1;
    }

    if (!thn.empty(prices) && currency) {
      widgetData.price = Math.min(...prices);
      widgetData.currency = currency;
      widgetData.set = true;
    }

    return widgetData;
  };

  /**
   * @memberOf module:bs_27
   * @this thn.widgets.booking
   * @see {@link Booking#set_data}
   *
   * @param {object} ctx - The context object.
   */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const bookingItems = thn.dataLayerHelper.get('items').filter((item) => item?.item_category?.match(/room/i));
    // check multirooms
    const multiRooms = bookingItems?.length > 1;
    const currency = thn.objectGet(window.dataLayer, 'currency', { first: false });
    const promocode = thn.dataLayerHelper.get('coupon');
    /* if there is more than one room with different confirmation numbers we go to multiroom
      where we send an array of objects with all rooms separately. */

    if (multiRooms) {
      // Dates, Price, BookingID
      const widgetDataMulti = [...bookingItems].map((room, index) => {
        const data = {
          dateBegin: room.item_checkin_iso?.replace(/-/g, '/'),
          dateEnd: room.item_checkout_iso?.replace(/-/g, '/'),
          price: room.item_room_amount,
          currency: thn.objectGet(window.dataLayer, 'currency', { first: false }),
          bookingId: room.item_id,
          adults: room.item_guest_total,
          children: 0, // no children option
          promocode,
        };
        return data;
      });

      if (!thn.empty(widgetDataMulti)) {
        return widgetDataMulti;
      }
      widgetData.set = false;
      return widgetData;

    }

    // Dates, Price, BookingID
    const bookingId = bookingItems?.[0]?.item_id;

    if (!bookingId) {
      widgetData.set = false;
      return widgetData;
    }

    widgetData.bookingId = bookingId;

    const dateBegin = bookingItems?.[0]?.item_checkin_iso || thn.objectGet(dataLayer, 'checkInDate', { first: false });
    const dateEnd = bookingItems?.[0]?.item_checkout_iso || thn.objectGet(dataLayer, 'checkOutDate', { first: false });

    widgetData.dateBegin = dateBegin?.replace(/-/g, '/');
    widgetData.dateEnd = dateEnd?.replace(/-/g, '/');

    const price = thn.objectGet(dataLayer, 'transactionTotal', { first: false });

    widgetData.price = price;
    widgetData.currency = currency;
    widgetData.promocode = promocode;

    return widgetData;
  };
  /**
   * @memberOf module:bs_27
   * @this thn.widgets.price
   * @see {@link Price#get_promocode}
   *
   * @param {object} ctx - The context object.
   */
  engine.getPromocode = function getPromocode(ctx) {
    const itemsObj = thn.dataLayerHelper.get('items');
    ctx.promocode = thn.parseUrlParameter('amp;prom') || thn.parseUrlParameter('prom') || document.querySelector('.PromoCodeInputInputOnly input')?.value || thn.objectGet(itemsObj, 'coupon');

    return ctx.promocode;
  };

  return engine;

}

export { factory };
